import { render, staticRenderFns } from "./TableComponentGenericSource.vue?vue&type=template&id=4a5ef84b&scoped=true&"
import script from "./TableComponentGenericSource.vue?vue&type=script&lang=js&"
export * from "./TableComponentGenericSource.vue?vue&type=script&lang=js&"
import style0 from "./TableComponentGenericSource.vue?vue&type=style&index=0&id=4a5ef84b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5ef84b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
